import React from "react";
import AuthUser from "../../../Hooks/authUser";
import PatientActivityReport from "../../Shared/PatientActivityReport";

const UserDashboardReports = () => {
  const { userInfo } = AuthUser();
  return (
    <PatientActivityReport
      userId={userInfo?._id}
      title="My Exercise Analytics"
      description="Track your game scores, training frequency, and overall recovery stats"
    />
  );
};

export default UserDashboardReports;
